import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * The "click a row → panel appears below the table" chrome (postal
 * reservations, returns, …): a titled card with a close button that shows a
 * spinner while loading, the error message on failure, or `children`
 * otherwise. For a full slide-over instead of an inline panel, use
 * `DetailDrawer`.
 */
export function InlineDetailPanel({
  title,
  onClose,
  isLoading,
  error,
  children,
}: {
  title: React.ReactNode;
  onClose: () => void;
  isLoading?: boolean;
  error?: Error | null;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-md border bg-card/50 p-3">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-medium">{title}</span>
        <Button size="sm" variant="ghost" onClick={onClose}>
          Close
        </Button>
      </div>
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      ) : error ? (
        <div className="text-sm text-destructive">{error.message}</div>
      ) : (
        children
      )}
    </div>
  );
}
